import styled from 'styled-components';

export const Container = styled.div`
  padding: 24px;

  .ant-select {
    display: block;
  }

  .ant-input-number {
    display: block;
    width: 100%;
  }
`;
